import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/** Nothing in the portal is saved before the officer has seen exactly what will change. */
export const ConfirmDialog = ({
  open,
  onOpenChange,
  title = "Are you sure?",
  description,
  changes = [],
  confirmLabel = "Yes, save it",
  cancelLabel = "No, go back",
  tone = "primary",
  onConfirm,
  testId = "confirm-dialog",
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="rounded-none bg-card" data-testid={testId}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-display text-lg font-bold">{title}</AlertDialogTitle>
        {description && (
          <AlertDialogDescription className="text-sm">{description}</AlertDialogDescription>
        )}
      </AlertDialogHeader>
      {changes.length > 0 && (
        <ul
          className="max-h-64 space-y-1.5 overflow-y-auto border border-border bg-background p-3"
          data-testid={`${testId}-changes`}
        >
          {changes.map((c, i) => (
            <li key={i} className="font-data text-[11px]" data-testid={`${testId}-change-${i}`}>
              <span className="text-muted-foreground">{c.label}: </span>
              <span className="line-through opacity-60">{String(c.from ?? "blank")}</span>
              <span className="mx-1.5">→</span>
              <span className="font-bold">{String(c.to ?? "blank")}</span>
            </li>
          ))}
        </ul>
      )}
      <AlertDialogFooter>
        <AlertDialogCancel
          className="h-10 rounded-none text-xs font-bold uppercase tracking-widest"
          data-testid={`${testId}-cancel`}
        >
          {cancelLabel}
        </AlertDialogCancel>
        <AlertDialogAction
          className={`h-10 rounded-none text-xs font-bold uppercase tracking-widest ${
            tone === "danger" ? "bg-[hsl(var(--at-risk))] text-white hover:bg-[hsl(var(--at-risk)/0.85)]" : ""
          }`}
          data-testid={`${testId}-confirm`}
          data-confirm={testId}
          onClick={onConfirm}
        >
          {confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
